import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/safeToast';
import App from './App';
import { AuthProvider } from './auth/JwtContext';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/global/ErrorFallback";
import { SnackbarProvider } from 'notistack';
import 'katex/dist/katex.min.css';
import './locales/i18n';
import { PermissionsProvider } from './auth/PermissionsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <PermissionsProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => window.location.reload()}>
          <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
            <App />
          </SnackbarProvider>
        </ErrorBoundary>
      </PermissionsProvider>
    </AuthProvider>
  </React.StrictMode>
);
